import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import { BrowserRouter } from 'react-router-dom';
import {Provider} from 'react-redux';
import {store} from './store/store';
import  ThemeContext  from "./context/ThemeContext.jsx";
import './i18n';

if (window.location.pathname.startsWith('/vite/demo')) {
  const nextPath = window.location.pathname.replace(/^\/vite\/demo/, '') || '/';
  window.history.replaceState(null, '', `${nextPath}${window.location.search}${window.location.hash}`);
}

if (window.location.pathname.startsWith('/vite/demo')) {
  const nextPath = window.location.pathname.replace(/^\/vite\/demo/, '') || '/';
  window.history.replaceState(null, '', `${nextPath}${window.location.search}${window.location.hash}`);
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
   <Provider store = {store}>
      <BrowserRouter>
        <ThemeContext>
          <App />
        </ThemeContext>
      </BrowserRouter>
    </Provider>
  </StrictMode>,
)
